import React from "react";

export default function CSS_StudyPlan() {
  return (
    <div className="tutorial-page">
      <h1>CSS StudyPlan</h1>
      <p>This is the CSS StudyPlan tutorial page.</p>
    </div>
  );
}
